import React, {Fragment, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {selectLang} from "../../../store/reducers/main/main";
import {Translate} from "../../../lang/lang";
import {
    deleteNotificationAsync,
    loadNotificationsAsync
} from "../../../store/reducers/telegram-notification/telegramNotification";
import toast from "react-hot-toast";
import {Button, Dropdown, Modal, Spinner} from "react-bootstrap";

const NotificationDelete = ({notification}) => {
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false)

    const lang = useSelector(selectLang)
    const t = Translate

    const handleShow = () => setShow(true)
    const handleClose = () => setShow(false)

    const removeNotification = (id) => {
        setLoading(true)
        deleteNotificationAsync(id)
            .then(() => {
                dispatch(loadNotificationsAsync())
                toast.success('Success')
            })
            .catch(e => {
                new Error(e)
                toast.error("Failure")
            })
            .finally(() => setLoading(false))
    }

    return (
        <Fragment>
            <Dropdown.Item onClick={handleShow}>
                {t(lang, "roaming.invoice.delete")}
            </Dropdown.Item>
            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{t(lang, "notification.delete.number.modal")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t(lang, "notification.confirmation.delete.number")} <b>+{notification?.phone_number}</b>?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t(lang, "notification.close_button")}
                    </Button>
                    <Button variant="danger" disabled={loading} onClick={() => removeNotification(notification.id)}
                            className="d-flex align-items-center gap-1">
                        {loading && <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />} {t(lang, "notification.delete_button")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};


export default NotificationDelete;
